import { render, staticRenderFns } from "./TradePage.vue?vue&type=template&id=ebe20b18&scoped=true"
import script from "./TradePage.vue?vue&type=script&lang=js"
export * from "./TradePage.vue?vue&type=script&lang=js"
import style0 from "./TradePage.vue?vue&type=style&index=0&id=ebe20b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe20b18",
  null
  
)

export default component.exports